import { render, staticRenderFns } from "./RequisitesFreeform.vue?vue&type=template&id=362d9d34"
import script from "./RequisitesFreeform.vue?vue&type=script&lang=js"
export * from "./RequisitesFreeform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports